// extracted by mini-css-extract-plugin
export var checkbox = "_9b-0";
export var circle = "_9b-3";
export var horizontalContainer = "_9b-7";
export var sm = "_9b-5";
export var switch0 = "_9b-2";
export var switchDisabled = "_9b-8";
export var switchEnabled = "_9b-1";
export var textSwitchContainer = "_9b-9";
export var textSwitchOption = "_9b-a";
export var textSwitchOptionSelected = "_9b-b";
export var verticalContainer = "_9b-6";
export var xs = "_9b-4";